import { environment } from "../../../environments/environment";
import { IParseable } from "../../shared/models/IParseable";

export class CandidateSummary implements IParseable {
    profileId: string;
    resumeId: string;
    photo: string;
    name: string;
    location: string;
    bookmarked: boolean;
    aboutMe: string;
    salary: number;
    salaryType: number;
    educationLevel: string;
    sector: string;
    experience: number;
    overallRating: number;

    parse(json: any): IParseable {
        let instance = new CandidateSummary();
        Object.assign(instance, json);
        if(instance.photo)
            instance.photo = `${environment.baseUrl}/${instance.photo}`;
        return instance;
    }

    static parse(json: any): CandidateSummary {
        let summary = new CandidateSummary();
        summary = summary.parse(json) as CandidateSummary;
        return summary;
    }
}
